var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "48px_box-arrow-top-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7832 2.60839H3.35661C2.42969 2.60839 1.67828 3.3598 1.67828 4.28671V17.7133C1.67828 18.6402 2.42969 19.3916 3.35661 19.3916H16.7832C17.7101 19.3916 18.4615 18.6402 18.4615 17.7133V4.28671C18.4615 3.3598 17.7101 2.60839 16.7832 2.60839Z",
    stroke: "#CC200D",
    strokeWidth: 1.34266,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5245 5.54545L9.65033 11.4196",
    stroke: "#CC200D",
    strokeWidth: 1.34266,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.4894 5.54545H15.5244V10.5804",
    stroke: "#CC200D",
    strokeWidth: 1.34266,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenTab);
export default __webpack_public_path__ + "static/media/openTab.3b303046216b015fc78b43c28cfa42c4.svg";
export { ForwardRef as ReactComponent };